import { collections, stats } from "@/mocks/animes";

export default function Collections() {
  return (
    <section id="pian" className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
      <div className="mb-8 flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
        <div>
          <span className="text-xs font-medium tracking-widest text-accent-600 uppercase">
            主题片单
          </span>
          <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-3xl">
            按心情挑一份片单
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            想大哭一场、深夜看美食，还是想回到童年？照着心情选就对了。
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {collections.map((c) => (
          <article
            key={c.id}
            className="group overflow-hidden rounded-lg bg-background-100 border border-background-200/70"
          >
            <div className="relative aspect-[3/2] overflow-hidden">
              <img
                src={c.image}
                alt={`${c.title} 片单封面`}
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 rounded-full bg-foreground-950/45 px-2.5 py-0.5 text-xs text-background-50 backdrop-blur">
                {c.count}
              </span>
            </div>
            <div className="p-4">
              <div className="flex items-center justify-between gap-2">
                <h3 className="font-heading text-base text-foreground-950">{c.title}</h3>
                <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-accent-100 px-2.5 py-0.5 text-xs text-accent-800">
                  <i className="ri-emotion-happy-line"></i> {c.mood}
                </span>
              </div>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
              <div className="mt-3 flex flex-wrap gap-1.5">
                {c.tags.map((t) => (
                  <span
                    key={t}
                    className="whitespace-nowrap rounded-full bg-background-200/80 px-2 py-0.5 text-xs text-foreground-700"
                  >
                    {t}
                  </span>
                ))}
              </div>
            </div>
          </article>
        ))}
      </div>

      <div className="mt-12 grid grid-cols-2 gap-4 rounded-lg bg-primary-500 p-6 md:grid-cols-4 md:p-8">
        {stats.map((s) => (
          <div key={s.label} className="text-center">
            <p className="font-heading text-3xl text-background-50 md:text-4xl">{s.value}</p>
            <p className="mt-1 text-sm text-primary-100">{s.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}